import { render, staticRenderFns } from "./Precios.vue?vue&type=template&id=0631b4ba"
import script from "./Precios.vue?vue&type=script&setup=true&lang=js"
export * from "./Precios.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports